if (!customElements.get('hc-faq-deal')) {
  class HcFaqDeal extends HTMLElement {
    connectedCallback() {
      this.headerToggle = this.querySelector('[data-js="faq-header-toggle"]');
      this.body = this.querySelector('[data-js="faq-body"]');
      this.chevronBtn = this.querySelector('.hc-faq-deal__toggle');
      if (!this.headerToggle || !this.body) return;

      if (this.classList.contains('is-open')) {
        this.body.style.maxHeight = 'none';
      }

      this._onToggle = this._handleToggle.bind(this);
      this._onTransitionEnd = this._handleTransitionEnd.bind(this);
      this.headerToggle.addEventListener('click', this._onToggle);
      this.body.addEventListener('transitionend', this._onTransitionEnd);
    }

    disconnectedCallback() {
      if (this.headerToggle) this.headerToggle.removeEventListener('click', this._onToggle);
      if (this.body) this.body.removeEventListener('transitionend', this._onTransitionEnd);
    }

    _handleToggle() {
      var isOpen = this.classList.contains('is-open');
      var body = this.body;

      if (isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.offsetHeight; // force reflow — transition won't fire without this
        body.style.maxHeight = '0px';
        this.classList.remove('is-open');
        this.classList.add('is-closed');
      } else {
        this.classList.remove('is-closed');
        this.classList.add('is-open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }

      if (this.chevronBtn) {
        this.chevronBtn.setAttribute('aria-expanded', String(!isOpen));
      }
    }

    _handleTransitionEnd(e) {
      if (e.target !== this.body) return;
      if (this.classList.contains('is-open')) {
        this.body.style.maxHeight = 'none';
      }
    }
  }

  customElements.define('hc-faq-deal', HcFaqDeal);
}
